module.exports = __webpack_public_path__ + "static/media/left-caret-white-circle-disabled.3584d329.svg";